import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../api";
import { Button, ButtonRow } from "../../components/button";
import { Card, CardContent, CardHeader } from "../../components/card";
import { CommandBar } from "../../components/command-bar";
import { Dashboard, DashboardTitle } from "../../components/dashboard";
import { FormControl, TextInput } from "../../components/form";
import { Icon } from "../../components/icon";
import { Section } from "../../components/layout";
import { DefaultRow, Table, TableActionCell, TableBody, TableCell, TableHeader, TableHeaderActionCell, TableHeaderCell, TableRow } from "../../components/table";
import { CopiableText, MutedText } from "../../components/text";
import { formatNumber } from "../../ui/format";
import { runOperation } from "../../ui/operation";
import { throttledCall } from "../../ui/throttle";

export default function (ctx) {
    const chatClients = el.state.create(null);
    const filter = el.state.create("");

    function refreshTable() {
        runOperation("Fetching chat clients...", async () => {
            const response = await api.getJson("/api/v1/web-chat-client");
            chatClients.value = response.data;
        });
    }

    refreshTable();

    return Dashboard(
        DashboardTitle(
            "Chat clients",
            "Here you can view and manage your chat clients."
        ),
        Section(
            CommandBar(
                Button(Icon("add-line"), "New chat client", {
                    onClick() {
                        page("/dashboard/chat-clients/create");
                    }
                })
            )
        ),
        Section(
            CommandBar(
                FormControl(null,
                    TextInput("searchInput", "Filter columns", {
                        onInput(event) {
                            throttledCall(() => {
                                filter.value = event.target.value;
                            }, 300);
                        }
                    })
                )
            )
        ),
        Section(
            Card(
                { class: "bg-card" },
                CardHeader(
                    "My chat clients"
                ),
                CardContent(
                    Table(
                        { class: "hoverable" },
                        TableHeader(
                            TableHeaderCell("Id."),
                            TableHeaderCell("Name"),
                            TableHeaderCell("Associated gateway"),
                            TableHeaderCell("Active sessions"),
                            TableHeaderActionCell("Actions")
                        ),
                        el.state.listening([chatClients, filter], () =>
                            TableBody(
                                chatClients.value?.map(client =>
                                    TableRow(
                                        TableCell(
                                            CopiableText(`#${client.id.substr(-4)}`, client.id)
                                        ),
                                        TableCell(client.name),
                                        TableCell(
                                            client.associatedGateway && Button(client.associatedGateway.name,
                                                Icon("arrow-right-line"),
                                                {
                                                    onClick() {
                                                        page(`/dashboard/gateways/${client.associatedGateway.id}`);
                                                    }
                                                }
                                            ) || MutedText("-")
                                        ),
                                        TableCell(formatNumber(client.activeSessions)),
                                        TableActionCell(
                                            ButtonRow(
                                                Button(
                                                    Icon("arrow-right-double-line"),
                                                    "Manage",
                                                    {
                                                        onClick() {
                                                            page(`/dashboard/chat-clients/${client.id}`);
                                                        }
                                                    }
                                                ),
                                                Button(
                                                    Icon("discuss-line"),
                                                    "Sessions",
                                                    {
                                                        onClick() {
                                                            page(`/dashboard/chat-clients/${client.id}/sessions`);
                                                        }
                                                    }
                                                )
                                            )
                                        )
                                    )
                                )?.nullWhenEmpty() || DefaultRow("No chat clients found.")
                            )
                        )
                    )
                )
            )
        )
    )
}
